import SEOArticleLayout from "@/components/feature/SEOArticleLayout";
import { comparisonSuperbuy } from "@/mocks/articles";

export default function HipobuyVsSuperbuy() {
  return (
    <SEOArticleLayout
      slug={comparisonSuperbuy.slug}
      title={comparisonSuperbuy.title}
      metaDescription={comparisonSuperbuy.metaDescription}
      publishDate={comparisonSuperbuy.publishDate}
      readTime={comparisonSuperbuy.readTime}
      badge={comparisonSuperbuy.badge}
      heroImage={comparisonSuperbuy.heroImage}
      sections={comparisonSuperbuy.sections}
      relatedArticles={[
        { label: "Complete Guide", to: "/hipobuy-spreadsheet-complete-guide" },
        { label: "vs Kakobuy", to: "/hipobuy-spreadsheet-vs-kakobuy" },
        { label: "vs CSSBuy", to: "/hipobuy-spreadsheet-vs-cssbuy" },
        { label: "vs Oopbuy", to: "/hipobuy-spreadsheet-vs-oopbuy" },
        { label: "Category Deep-Dive", to: "/hipobuy-spreadsheet-category-deep-dive" },
      ]}
    />
  );
}